module.exports = __webpack_public_path__ + "img/Image2.062ad163.png";